const biometricData = [
  { label: "Pesagem", id: "pesagem" },
  { label: "Peso do Leite (controle do leite)", id: "pesoDoLeite" },
];

const others = [
  {
    label: "Diagnóstico de Prenhez",
    id: "diagnosticoDePrenhez",
  },
  { label: "Exame Ginecológico", id: "exameGinecologico" },
  { label: "Inseminação Artificial", id: "inseminacaoArtificial" },
  { label: "Observação de Cio", id: "observacaoDoCio" },
  {
    label: "Protocolo de Sincronização (IATF, TETF)",
    id: "protocoloDeSincronizacao",
  },
];

const restroomAndVet = [
  {
    label: "Administração de Medicamentos",
    id: "administracaoDeMedicamentos",
  },
  {
    label: "Aplicação de ectoparasiticidas",
    id: "aplicaçãoDeEctoparasiticidas",
  },
  {
    label: "Aplicação de endoparasiticidas",
    id: "aplicaçãoDeEndoparasiticidas",
  },
  { label: "Aplicação de vacinas", id: "aplicaçãoDeVacinas" },
  { label: "Exame de Brucelose", id: "exameDeBrucelose" },
  { label: "Procedimento Cirúrgico", id: "procedimentoCirurgico" },
  { label: "Tuberculinização", id: "tuberculinização" },
];

const maintenance = [
  {
    label: "Casqueamento",
    id: "casqueamento",
  },
  {
    label: "Pedilúvio",
    id: "pediluvio",
  },
];

export { biometricData, others, restroomAndVet, maintenance };
